import { useVisibleFreefieldCategoriesWithValues } from "shared/utils/freeFields/hooks";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";

export const sidePanelFreeFieldSections = (
  categories: server.dto.FreeFieldCategorySmall[],
  freefieldValues: server.dto.FreeFieldValue[],
): FormSection[] => {
  const freeFieldCategoriesWithValues = useVisibleFreefieldCategoriesWithValues(categories, freefieldValues);
  const freeFieldCategoriesThatHaveVisibleValues = freeFieldCategoriesWithValues.filter(category => category.definitionWithValues.some(ffValue => ffValue.displayValue.hasVisibleValue));

  return freeFieldCategoriesThatHaveVisibleValues.map(category => ({
    key: `free-field-category-${category.freeFieldCategoryId}`,
    type: "collapsable",
    title: category.title,
    fields: category.definitionWithValues
      .filter(ffValue => ffValue.displayValue.hasVisibleValue)
      .map(ffValue => ({
        key: `free-field-definition-${ffValue.freeFieldDefinitionId}`,
        label: ffValue.title,
        sublabel: ffValue.description,
        render: () => <ReadonlyFreefieldValue type={ffValue.type} displayValue={ffValue.displayValue} />,
      })),
  }));
}
